module.exports = __webpack_public_path__ + "static/media/tire-pressure-check-red.56b21493.svg";